"use client";
import React, { useState } from "react";
import { Checkbox } from "@nextui-org/react";
import { useContext } from "react";
import { RecentLeaderContext } from "@/components/server/RecentLeaderBoardContainer/context";
import GoalTimeStats from "./GoalTimeStats";
import MatchDetail from "./MatchDetail";
const GoalStatistic = ({ goalStats }) => {
  const { home, away } = useContext(RecentLeaderContext);

  return (
    <>
      {/*Thời gian ghi bàn*/}
      <GoalTimeStats home={home} away={away} goalStats={goalStats} />
      
      {/*Chi tiết về HT/FT*/}
      <MatchDetail home={home} away={away} goalStats={goalStats} />

      {/*Thống kê Hiệu số bàn thắng thua FT/HT*/}
      {/* <div className={" px-0 lg:px-8 py-4"}>
        <div className="flex flex-col mt-6">
          <div className="flex font-semi-bold">
            <div className="lg:flex-1 bg-custom-gradient-compare-strength pl-4 pt-[5px] rounded-tl-[4px] rounded-tr-[4px] text-white text-sm">
              {home.name}
            </div>
            <div className="lg:flex-1 text-center font-semi-bold text-black text-sm">
              Thống kê tỷ lệ kèo lịch sử tương đồng
            </div>
            <div className="lg:flex-1 bg-custom-gradient-compare-strength-away text-right pr-[10px] pt-[5px] text-button-blue-bet text-sm">
              {away.name}
            </div>
          </div>
          <div className="flex">
            <div
              className="flex flex-col text-center h-[7px] bg-button-blue-bet"
              style={{ width: "51%" }}
            ></div>
            <div
              className="text-center h-[7px] bg-golden-yellow"
              style={{ width: "49%" }}
            ></div>
          </div>
        </div>
        <div className={"px-0 lg:px-[34px]"}>
          <div className={"flex flex-row mt-4 [&>*]:flex-1 "}>
            <div className={"flex flex-row justify-between mb-4 "}>
              <div
                className={
                  "flex flex-col lg:flex-row justify-start gap-1 lg:gap-4 [&>*]:flex [&>*]:flex-row  [&>*]:justify-start lg:[&>*]:justify-center [&>*]:items-center [&>*]:gap-2 "
                }
              >
                <div>
                  <div className={"w-3.5 h-3.5 bg-button-blue-bet"}></div>
                  <div className={""}>Chủ</div>
                </div>
                <div>
                  <div className={"w-3.5 h-3.5 bg-golden-yellow"}></div>
                  <div className={""}>Khách</div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={
              "w-full font-bold text-xs  flex flex-row gap-8 lg:gap-20 [&>*]:flex-1 [&>*]:text-center [&>*:first-child]:pl-[0] [&>*:last-child]:pr-[0] divide-league-dark-detail text-blur-gray"
            }
          >
            <div className={"flex flex-col gap-2 "}>
              <div className={"flex flex-row gap-2 [&>*]:flex-1 "}>
                <div
                  className={
                    "h-[88px] flex flex-col justify-end bg-[#ebeff5] rounded-tl rounded-tr text-button-blue-bet"
                  }
                >
                  <div>1</div>
                  <div
                    className={"h-full bg-button-blue-bet"}
                    style={{ height: "20%" }}
                  ></div>
                </div>
                <div
                  className={
                    " h-[88px] flex flex-col justify-end bg-[#f6f5ef] rounded-tl rounded-tr text-golden-yellow"
                  }
                >
                  <div>1</div>
                  <div
                    className={"h-full bg-golden-yellow"}
                    style={{ height: "20%" }}
                  ></div>
                </div>
              </div>
              <div className={"w-full rounded font-semi-bold text-center"}>
                Thắng 2+ bàn
              </div>
            </div>

            <div className={"flex flex-col gap-2 "}>
              <div className={"flex flex-row gap-2 [&>*]:flex-1 "}>
                <div
                  className={
                    "h-[88px] flex flex-col justify-end bg-[#ebeff5] rounded-tl rounded-tr text-button-blue-bet"
                  }
                >
                  <div>0</div>
                  <div
                    className={"h-full bg-button-blue-bet"}
                    style={{ height: "1%" }}
                  ></div>
                </div>
                <div
                  className={
                    " h-[88px] flex flex-col justify-end bg-[#f6f5ef] rounded-tl rounded-tr text-golden-yellow"
                  }
                >
                  <div>1</div>
                  <div
                    className={"h-full bg-golden-yellow"}
                    style={{ height: "20%" }}
                  ></div>
                </div>
              </div>
              <div className={"w-full rounded font-semi-bold text-center"}>
                Thắng 1 bàn
              </div>
            </div>
            <div className={"flex flex-col gap-2 "}>
              <div className={"flex flex-row gap-2 [&>*]:flex-1 "}>
                <div
                  className={
                    "h-[88px] flex flex-col justify-end bg-[#ebeff5] rounded-tl rounded-tr text-button-blue-bet"
                  }
                >
                  <div>0</div>
                  <div
                    className={"h-full bg-button-blue-bet"}
                    style={{ height: "1%" }}
                  ></div>
                </div>
                <div
                  className={
                    " h-[88px] flex flex-col justify-end bg-[#f6f5ef] rounded-tl rounded-tr text-golden-yellow"
                  }
                >
                  <div>1</div>
                  <div
                    className={"h-full bg-golden-yellow"}
                    style={{ height: "20%" }}
                  ></div>
                </div>
              </div>
              <div className={"w-full rounded font-semi-bold text-center"}>
                Hòa
              </div>
            </div>
            <div className={"flex flex-col gap-2 "}>
              <div className={"flex flex-row gap-2 [&>*]:flex-1 "}>
                <div
                  className={
                    "h-[88px] flex flex-col justify-end bg-[#ebeff5] rounded-tl rounded-tr text-button-blue-bet"
                  }
                >
                  <div>0</div>
                  <div
                    className={"h-full bg-button-blue-bet"}
                    style={{ height: "1%" }}
                  ></div>
                </div>
                <div
                  className={
                    " h-[88px] flex flex-col justify-end bg-[#f6f5ef] rounded-tl rounded-tr text-golden-yellow"
                  }
                >
                  <div>1</div>
                  <div
                    className={"h-full bg-golden-yellow"}
                    style={{ height: "20%" }}
                  ></div>
                </div>
              </div>
              <div className={"w-full rounded font-semi-bold text-center"}>
                Mất 1 bàn
              </div>
            </div>
            <div className={"flex flex-col gap-2 "}>
              <div className={"flex flex-row gap-2 [&>*]:flex-1 "}>
                <div
                  className={
                    "h-[88px] flex flex-col justify-end bg-[#ebeff5] rounded-tl rounded-tr text-button-blue-bet"
                  }
                >
                  <div>0</div>
                  <div
                    className={"h-full bg-button-blue-bet"}
                    style={{ height: "1%" }}
                  ></div>
                </div>
                <div
                  className={
                    " h-[88px] flex flex-col justify-end bg-[#f6f5ef] rounded-tl rounded-tr text-golden-yellow"
                  }
                >
                  <div>1</div>
                  <div
                    className={"h-full bg-golden-yellow"}
                    style={{ height: "20%" }}
                  ></div>
                </div>
              </div>
              <div className={"w-full rounded font-semi-bold text-center"}>
                Mất 2+ bàn
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default GoalStatistic;
